import { websocketService } from "./websocket.service";

class InitializationService {
    public initialize() {
        // Initialize WebSocket connection
        websocketService.connect();

        // Add any other initialization logic here
    }
}

export const initService = new InitializationService();
